
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('rect',{attrs:{"width":"3.5","height":"10","rx":".5","transform":"translate(3 3)"}}),_vm._v(" "),_c('rect',{attrs:{"width":"3.5","height":"10","rx":".5","transform":"translate(9.5 3)"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  